import { AddressModel } from '@steelbuy/ts-shared';

import { AddressEntityData } from './AddressEntityData';
import { useEntityData } from '../../util/consumer/EntityConsumerHook';

export const useAddressEntityData = () => useEntityData<AddressModel>(AddressEntityData);
